
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Bike } from '@/services/types';

interface BulkActionConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  actionType: 'block' | 'unblock' | 'speed-limit' | 'reset';
  selectedBikes: Bike[];
  onConfirm: () => void;
  speedLimit?: number;
}

export const BulkActionConfirmDialog: React.FC<BulkActionConfirmDialogProps> = ({
  open,
  onOpenChange,
  actionType,
  selectedBikes,
  onConfirm,
  speedLimit
}) => {
  const getActionDetails = () => {
    switch (actionType) {
      case 'block':
        return {
          title: 'Подтвердите блокировку',
          description: `Вы действительно хотите заблокировать ${selectedBikes.length} велосипедов?`,
          action: 'Заблокировать'
        };
      case 'unblock':
        return {
          title: 'Подтвердите разблокировку',
          description: `Вы действительно хотите разблокировать ${selectedBikes.length} велосипедов?`,
          action: 'Разблокировать'
        };
      case 'speed-limit':
        return {
          title: 'Подтвердите ограничение скорости',
          description: `Вы действительно хотите установить ограничение скорости ${speedLimit} км/ч для ${selectedBikes.length} велосипедов?`,
          action: 'Установить ограничение'
        };
      case 'reset':
        return {
          title: 'Подтвердите сброс ограничений',
          description: `Вы действительно хотите сбросить все ограничения для ${selectedBikes.length} велосипедов?`,
          action: 'Сбросить ограничения'
        };
      default:
        return {
          title: 'Подтвердите действие',
          description: `Вы действительно хотите выполнить это действие для ${selectedBikes.length} велосипедов?`,
          action: 'Выполнить'
        };
    }
  };

  const details = getActionDetails();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{details.title}</AlertDialogTitle>
          <AlertDialogDescription>
            {details.description}
            <br />
            <span className="text-sm text-muted-foreground mt-2 block">
              Это действие нельзя будет отменить.
            </span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Отмена</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {details.action}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
